"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonViewer = void 0;
const react_1 = __importDefault(require("react"));
const JsonViewer = ({ json }) => {
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("code", null,
            react_1.default.createElement("pre", null, JSON.stringify(json, null, 2)))));
};
exports.JsonViewer = JsonViewer;
//# sourceMappingURL=index.js.map